<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <div>
      <b-row style="max-width: 100%" class="padding-ten-tb">
        <b-col xs="12" sm="12" md="12" lg="4">
          <h5 class="color-gray">Técnicos</h5>
        </b-col>
      </b-row>
    </div>
    <div class="bg-white padding-five-all">
      <h5 class="color-orange">Búsqueda</h5>
      <b-container fluid>
        <b-row>
          <b-col cols="12" sm="9" md="4" lg="4">
            <label class="text-grey">Proveedor</label>
            <b-form-group>
              <b-form-select
                @change="clearSelectedValues"
                v-model="selectedFilter"
                size="md"
                :options="optionsTypeDoc"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="9" md="4" lg="4" v-if="selectedFilter == 'a'">
            <label class="text-grey">Número de documento Tec.</label>
            <b-form-input
              type="text"
              v-on:keyup.enter="getTechnicians"
              v-model="documentValue"
              placeholder="Escriba aquí"
            ></b-form-input>
          </b-col>
          <b-col
            cols="12"
            sm="9"
            md="4"
            lg="4"
            v-else-if="selectedFilter == 'b'"
          >
            <label class="text-grey">Usuario Proveedor</label>
            <template v-if="isProfileProvider">
            <b-form-input
              v-if="isProfileProvider"
              :disabled="true"
              type="text"
              :value="username"
              placeholder="Escriba aquí"
            ></b-form-input>
            </template>
         
            <template v-else>
                  <b-form-group>
                    <b-form-select
                      v-model="provider"
                      size="md"
                      :options="optionsProvider"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="0"
                        >
                          Todos
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </template> 
          </b-col>
          <b-col cols="12" sm="9" md="4" lg="4">
            <label class="text-grey">Nombre del técnico</label>
            <b-form-input
              v-on:keyup.enter="getTechnicians"
              type="text"
              v-model="techName"
              placeholder="Escriba aquí"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="4">
            <label class="text-grey">Estado</label>
            <b-form-group>
              <b-form-select
                v-model="selectedState"
                size="md"
                :options="optionStates"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="padding-ten-tb">
          <b-col xs="12" sm="12" md="12" lg="4" style="text-align: left">
            <b-button class="bg-grey-btn hidden-icon" @click="clearValues">
              <font-awesome-icon icon="broom" s /> Limpiar
            </b-button>
            <b-button
              @click="getTechnicians"
              class="bg-orange-btn width-1000 padding-six-right"
            >
              <font-awesome-icon icon="search" /> Buscar
            </b-button>
          </b-col>
          <b-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
            text-right
            text-left-xs
            v-if="optionCreate"
          >
            <b-button
              class="bg-orange-btn width-1000"
              v-b-modal.modal-registrar-tec
            >
              <font-awesome-icon icon="plus" /> Agregar
            </b-button>
            
            <b-modal
              no-close-on-backdrop
              hide-footer
              id="modal-registrar-tec"
              title="Datos del técnico"
            >
              <register-technician> </register-technician>
            </b-modal>
          </b-col>
          <b-col lg="2" v-show="!isProfileProvider">
              <b-button @click="generateExcelFile">
                Exportar
              </b-button>
            </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="bg-white padding-five-all">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <h5 class="color-orange">Resultados</h5>
          
          </b-col>
        </b-row>
        <b-table
          class="hidden-xs"
          show-empty
          small
          :busy="isBusy"
          striped
          :items="technicians"
          :fields="fields"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button
              v-show="optionEdit"
              size="sm" 
              @click="setTechId(row.item, $event.target)"
              class="mr-1 btn-orange-tra bg-grey color-dark"
              ><font-awesome-icon icon="edit" />
            </b-button>
            <b-button
              :disabled="row.item.state == 'INACTIVE'"
              v-show="optionInactive"
              size="sm"
              @click="deleteTechnician(row.item, $event.target)"
              class="mr-1 btn-orange-tra bg-grey color-dark"
              ><font-awesome-icon icon="trash" />
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalTechnicians"
          :per-page="perPage"
          pills
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-container>
    </div>
    <div>
      <b-modal
        v-model="showModalEdit"
        no-close-on-backdrop
        @hidden="onHidden"
        hide-footer
        id="modal-editar-tec"
        title="Datos del técnico"
      >
        <edit-technician :techId="techId" :showModalEdit.sync="showModalEdit">
        </edit-technician>
      </b-modal>
      <b-modal 
        v-model="showModalReport"
        no-close-on-backdrop
        hide-footer
        id="modal-reporte-tec"
        title="Reporte de técnicos"
      >
        <report-technician :showModalReport.sync="showModalReport" />
      </b-modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import RegisterTechnician from "../../components/Tecnicos/RegisterTechnician.vue";
import EditTechnician from "../../components/Tecnicos/EditTechnician.vue";
import ReportTechnician from "../../components/Tecnicos/ReportTechnician.vue"
//import FileSaver from "file-saver";
import { mapState } from "vuex";
export default {
  components: { RegisterTechnician, EditTechnician, ReportTechnician },
  name: "Tecnicos",
  data() {
    return {
      showModalReport:false,
      optionsProvider:[],
      showModalEdit: false,
      techId: "",
      provider: "",
      sortBy: "",
      currentPage: 1,
      perPage: 10,
      countTotal: 0,
      optionsTypeDoc: [
        { value: "a", text: "Doc. Identidad" },
        { value: "b", text: "Usuario del Proveedor" },
      ],
      selectedFilter: "a",
      documentValue: "",
      providers: [],
      selectedState: "ALL",
      optionStates: [
        { value: "ACTIVE", text: "Activo" },
        { value: "INACTIVE", text: "Inactivo" },
        { value: "ALL", text: "Todos" },
      ],
      fields: [
        {
          key: "providerId",
          label: "Código",
        },
        {
          key: "providerName",
          label: "Proveedor",
        },
        {
          key: "state",
          label: "Estado",
        },
        {
          key: "name",
          label: "Técnico",
        },
        { key: "identityDocument", label: "Doc. Identidad", sortable: true },
        { key: "phone", label: "Teléfono", sortable: true },
        { key: "actions", label: "" },
      ],
      isBusy: false,
      technicians: [],
      techName: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapState("module", ["options", "name", "perfil","username","idProvider","token"]),
    optionCreate() {
      //id 14 Crear
      return this.options.some((m) => m.id == 14);
    },
    optionEdit() {
      //id 15 Editar
      return this.options.some((m) => m.id == 15);
    },
    optionInactive() {
      //id 19 Inactivar
      return this.options.some((m) => m.id == 19);
    },
    totalTechnicians() {
      if (this.currentPage == 1 && this.technicians.length < 10) return 10;
      return this.countTotal;
    },
    isProfileProvider() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return true;
      return false;
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.getTechnicians().catch((error) => {
          console.error(error);
        });
      },
    },
  },
  created() {
    //this.getTechnicians();
    this.getFilteredProviders();
    this.getCountTechnicians();
  },
  methods: {
    async getFilteredProviders() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/providers?limit=1000&page=1&pagination=false"
        );

        const data = response.data.map((row) => {
          return {
            value: row.user,
            text: row.user,
          };
        });
        this.optionsProvider = data;
      } catch (error) {
        console.log(error);
      }
    },
        generateExcelFile() {
          this.showModalReport=true;
      /*this.$store.commit("SET_LOADING", true);
      let providerName = this.isProfileProvider ? this.idProvider : this.provider;
      axios
        .get(
          process.env.VUE_APP_ORDERS_CORE_BASE_EXT + "/report-technicians?idProv=" +
            providerName,
          {
            responseType: "blob",
          }
        )

        .then((response) => {
          FileSaver.saveAs(response.data, "Tecnicos.xlsx");
        })

        .finally(() => this.$store.commit("SET_LOADING", false)); */
    },
    onHidden() {
      if (this.techId) this.techId = null;
    },
    async getCountTechnicians() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/technicians/count",
            {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
              },
            }
        );

        this.countTotal = response.data.number;
      } catch (error) {
        this.countTotal = 100;
      }
    },
    clearSelectedValues() {
      this.documentValue = "";
      this.provider = "";
    },
    clearValues() {
      this.provider = "";
      this.techName = "";
      this.documentValue = "";
    },
    async getTechnicians() {
      try {
        this.isBusy = true;
        let providerName = this.isProfileProvider ? this.username : this.provider;
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/technicians?limit=" +
            this.perPage +
            "&page=" +
            this.currentPage +
            "&providerName=" +
            providerName +
            "&identityDocument=" +
            this.documentValue +
            "&technicianName=" +
            this.techName +
            "&state=" +
            this.selectedState
        );
        console.log(this.technicians);
        this.technicians = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    /* async getTechnicians() {
      try {
        this.isBusy = true;
        let response = await axios.get(
          "http://10.20.12.134:31006/technicians?limit=10&page=1&providerName=" +
            this.provider +
            "&identityDocument=" +
            this.documentValue +
            "&technicianName=" +
            this.techName+
            "&state="+
            this.selectedState
        );

        this.technicians = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    }, */
    setTechId(item) {
      this.techId = item.id;
      this.showModalEdit=true;
    },
    async deleteTechnician(item) {
      try {
        this.isBusy = true;
        this.$store.commit("SET_LOADING", true);
        let response = await axios.delete(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS + "/technicians/" + item.id
        );
        console.log(response);

        let values = {
          variant: "success",
          msg: "Se ha inactivado exitosamente !",
        };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.getProviders();
        //this.providers = response.data;
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        this.isBusy = false;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}

.padding-ten-lr {
  padding: 10px;
  padding-left: 35px !important;
}
.color-gray {
  color: #676767;
  font-weight: bold;
}

.color-orange {
  color: #ff7a00;
}

.btn-orange-tra {
  border-radius: 50%;
}
.bg-grey {
  background-color: #ececec;
  border-color: transparent;
  color: #bbbbbb;
}

.bg-grey-btn {
  background-color: #676767;
  border-radius: 20px;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}
::v-deep .modal-header {
  border-bottom: none;
}
.padding-six-right {
  margin-left: 20px;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
::v-deep .table td {
  color: black;
  font-size: 11pt;
}
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
</style>
